import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, BasicApiResponseModel, Core2Config, ApiVisa } from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';
import { InvResetMovingAverageCostModel } from '../../../../../../models/aggregates/erp/stock/reset-moving-average-cost.model';


@Injectable({
  providedIn: 'root'
})
export class InventoryResetMovingAverageCostService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "reset-moving-average-costs/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "reset-moving-average-costs/backoffice-ep";
        this.httpClient = http;
      }

      public updatePostingStatus(dtoObject: any, apiVisa: ApiVisa, reset_ma_cost_guid: string) {
        let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "reset-moving-average-costs/update-posting-status/backoffice-ep/" + reset_ma_cost_guid
        return this.httpClient.put<ApiResponseModel<any>>(
          apiUrl,
          dtoObject,
          this.getHttpHeader(apiVisa)
        );
      }

      public autoCreateAndFinal(genericDocLineGuid: string, apiVisa: ApiVisa) {
        let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "reset-moving-average-costs/auto-create-and-final/backoffice-ep/" + genericDocLineGuid
        return this.httpClient.post<BasicApiResponseModel<InvResetMovingAverageCostModel>>(
          apiUrl, this.getHttpHeader(apiVisa)
        );
      }
  
      public directUpdate(payload: any, apiVisa: ApiVisa) {
        let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "reset-moving-average-costs/direct-update/backoffice-ep"
          return this.httpClient.put<ApiResponseModel<any>>(
            apiUrl,
            payload,
            this.getHttpHeader(apiVisa)
          );
      }

}